import { useState } from "react";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import PropTypes from "prop-types";
import { ModalContainer, CloseIcon } from "./Modal.styled";
import CONSTANT from "../../constants/constant";
import Icon from "../Icon/Icon";

export default function ModalDialog({ isOpen, onClose, children }) {
  const [open, setOpen] = useState(isOpen);
  const handleClose = (_, reason) => {
    if (reason && reason === "backdropClick") return;
    setOpen(false);
    onClose(CONSTANT.CLOSE);
  };

  return (
    <Modal open={open} closeAfterTransition>
      <Fade in={open}>
        <ModalContainer>
          <CloseIcon onClick={handleClose}>
            <Icon type={CONSTANT.ICON.CLOSE} size="20px"></Icon>
          </CloseIcon>
          {children}
        </ModalContainer>
      </Fade>
    </Modal>
  );
}

ModalDialog.propTypes = {
  isOpen: PropTypes.bool,
  status: PropTypes.object,
};
